import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Spinner from '../Spinner';

const Preloader = ({ text, darkBackground, children }) => {
  const spinnerClass = classnames({
    'spinner--on-dark': darkBackground
  });
  return (
    <div className="preloader">
      <div className="preloader__spinner">
        <Spinner className={spinnerClass} />
      </div>
      <div className="preloader__text">
        {text || children}
      </div>
    </div>
  );
};

Preloader.propTypes = {
  text: PropTypes.string,
  darkBackground: PropTypes.bool,
  children: PropTypes.node
};

export default Preloader;
